import { GridStack } from "gridstack";
import DMSHeader from "../DMSHeader/DMSHeader";

import GridItem from "../../../Components/UiComponents/GridItem/GridItem";
import { useEffect } from "react";
import GpsTrackViewDetails from "./GpsTrackViewDetails";



// Component for rendering ATM table details
const GpsTrackView = () => {
  // Initialize GridStack layout system on component mount
  useEffect(() => {
    GridStack.init();
  }, []);

  // Define grid layout configuration with header and form components
  const layoutData = [
    {
      x: 0,
      y: 0,
      width: 12,
      height: 1,
      id: 0,
      component: (
        <DMSHeader
          title="View GPS Track Details"
          showdownload={false}
          fileName="GpsTrackView Details"
          showIconsForback={true}
        />
      ),
      haveOverflowVisible: true,
    },
    {
      x: 0,
      y: 1,
      width: 12,
      height: 13,
      id: 1,
      component: <GpsTrackViewDetails />,
    },
  ];

  // Render grid container with layout items
  return (
    <div className="grid-stack grid-stack-instance-1 smartpole__header--transition ">
      <GridItem layoutData={layoutData} />
    </div>
  );
};

export default GpsTrackView;
